export const LINKING_STAGES = {
  MEMBER_TOKEN_REFRESH: 'MEMBER_TOKEN_REFRESH',
  LINKEDIN_AUTHENTICATION: 'LINKEDIN_AUTHENTICATION',
  COMPANY_PAGE_SELECTION: 'COMPANY_PAGE_SELECTION',
  REQUEST_ACCESS: 'REQUEST_ACCESS',
  PERMISSION_CHECK: 'PERMISSION_CHECK',
};
